import React, { useEffect, useState } from "react";
import {
  Box, Button, Flex, Select, useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
  IconButton,
} from "@chakra-ui/react";
import Header from "../../../components/header/Header";
import PitchRequestsCountCard from "./PitchRequestsCountCard";
import PitchRequestsTable from "./PitchRequestsTable";
import useData from "../../../data/useData";
import { useSelector } from "react-redux";
import PermissionBlinder from "../../../components/PermissionBlinder";
import moment from "moment";
import { BASE_URL } from "../../../helpers/constant";
import client from "../../../libs/client";
import dayjs from "dayjs";
import { DatePicker, Space } from 'antd';

import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

import { BsDownload } from 'react-icons/bs';
import exportToCSV from '../../../utils/ExportToCSV';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
const { RangePicker } = DatePicker;

const PitchRequests = () => {
  const [from, setFrom] = useState(
    moment().startOf('month').format('YYYY-MM-DD'),
  );
  const [to, setTo] = useState(moment().format('YYYY-MM-DD'));
  const [comparisonValue, setComparisonValue] = useState('month');
  const [diff, setDiff] = useState('week');
  const [pitchRequests, setPitchRequests] = useState()
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [pageSize, setPageSize] = useState(25)
  const permissions = useSelector(
    (state) => state?.user?.userInfo?.permissions,
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: pitchRequestsData, isLoading, isError, refetch } = useData(`admin/pitch-requests?dateSubmittedFrom=${from}&dateSubmittedTo=${to}&page=${page}&pageSize=${pageSize}`)

  useEffect(() => {
    if (pitchRequestsData?.data) {
      setPitchRequests(pitchRequestsData?.data || [])
      setPageSize(pitchRequestsData?.pageSize || 25)
      setTotalPages(pitchRequestsData?.totalPages ?? 1)
      setCount(pitchRequestsData?.totalItems ?? 0)
    }
  }, [refetch, pitchRequestsData])


  useEffect(() => {
    if (comparisonValue === 'week') {
      setFrom(moment().startOf('week').format('YYYY-MM-DD'));
      setTo(moment().format('YYYY-MM-DD'));
    } else if (comparisonValue === 'month') {
      setFrom(moment().startOf('month').format('YYYY-MM-DD'));
      setTo(moment().format('YYYY-MM-DD'));

    } else if (comparisonValue === 'year') {
      setFrom(moment().startOf('year').format('YYYY-MM-DD'));
      setTo(moment().format('YYYY-MM-DD'));
    } else if (comparisonValue === 'all') {
      setFrom(
        moment().subtract(19, 'year').startOf('year').format('YYYY-MM-DD'),
      );
      setTo(moment().format('YYYY-MM-DD'));
    } else {
      onOpen();
    }
  }, [comparisonValue]);

  useEffect(() => {
    let _diff = moment(to).diff(from, 'day');
    if (_diff < 8) {
      setDiff('day');
    } else if (_diff < 80) {
      setDiff('week');
    } else if (_diff < 367) {
      setDiff('month');
    } else if (_diff < 730) {
      setDiff('quarter');
    } else {
      setDiff('year');
    }
    refetch();
  }, [from, to, page]);

  const onComparisonChange = (e) => {
    setComparisonValue(e.target.value);
  };

  if (permissions && !permissions?.can_manage_pitch_requests) {
    return <PermissionBlinder />
  }

  const onCalendarChange = (date) => {
    if (date && date.length === 2) {
      let _from = moment(date[0].toDate()).format('YYYY-MM-DD');
      let _to = moment(date[1].toDate()).format('YYYY-MM-DD');

      // Ensure from date is not in the future
      if (moment(_from).isAfter(moment())) {
        _from = moment().format('YYYY-MM-DD');
      }

      // Ensure to date is not in the future
      if (moment(_to).isAfter(moment())) {
        _to = moment().format('YYYY-MM-DD');
      }

      setFrom(_from);
      setTo(_to);
    }
  };

  return (
    <>
      <Box>
        <Header title='PitchRequests' />
        <Box px={15} py={5}>

          <Box className="flex items-center gap-5 mb-20 w-full">
            <PitchRequestsCountCard data={count} />
            <Flex className="max-w-xl">
              {/* <Select value={systemComparisonValue} onChange={onSystemComparisonChange} placeholder=''> */}
              <Select
                value={comparisonValue}
                onChange={onComparisonChange}
                placeholder=""
              >
                {/* <option value='today'>Today</option> */}
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
                <option value="all">All Time</option>
                <option value="custom">Custom</option>
              </Select>
            </Flex>
            {comparisonValue === 'custom' && (
              <Button colorScheme="blue" onClick={onOpen}>
                Change custom selection
              </Button>
            )}
          </Box>
          <PitchRequestsTable refetch={refetch} isLoading={isLoading} requests={pitchRequests} />

          <Flex justify="center" align="center" className="mt-10 gap-4">
            {/* Previous Button */}
            <IconButton
              aria-label="Previous Page"
              icon={<FaChevronLeft />}
              size="sm"
              variant="ghost"
              colorScheme="gray"
              isDisabled={page == 1}
              className="bg-gray-400 border rounded"

              onClick={() => {
                if (page > 1) {
                  setPage(prev => prev - 1)
                }
              }}
            />

            {/* Page Numbers */}
            <Text className="font-medium">
              {page}
            </Text>

            {/* Next Button */}
            <IconButton
              aria-label="Next Page"
              icon={<FaChevronRight />}
              size="sm"
              variant="ghost"
              colorScheme="gray"
              className="bg-gray-400 border rounded"
              isDisabled={page == totalPages}
              onClick={() => {
                if (page < totalPages) {
                  setPage(prev => prev + 1)
                }
              }}
            />
          </Flex>
        </Box>
      </Box>

      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Select Custom Range</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex className="mb-5 flex-col gap-5 items-center">
                <Flex className="w-full items-start flex-col gap-2">
                  <Text>
                    Current Date Range: {from} to {to}
                  </Text>
                  <Text className="text-xs italic">
                    N/B: Date format is YYYY-MM-DD
                  </Text>
                </Flex>
                <RangePicker
                  value={[dayjs(from), dayjs(to)]}
                  maxDate={dayjs()}
                  onChange={onCalendarChange}
                  format="YYYY-MM-DD"
                />
              </Flex>
            </ModalBody>
            <ModalFooter>  {/* Moved outside ModalBody */}
              <Button onClick={onClose} colorScheme="blue">
                See Results
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    </>
  )
}
export default PitchRequests;